import React from "react";

export default function ContactSectionContacts() {
  return (
    <React.Fragment>
      <>
        <section className="relative py-20 md:py-32 overflow-hidden" id="form">
          <iframe
            src="https://v2-embednotion.com/19d5649ef5708000bee3d8fb825db066"
            style={{
              width: "100%",
              height: "1200px",
              border: "2px solid #ccc",
              borderRadius: "10px",
              padding: "none",
            }}
          ></iframe>
        </section>
      </>
    </React.Fragment>
  );
}
